
import React from "react";
import { Classname } from "@rivtn/noseur";

export interface StatefulLinkProps {
    className?: string;
    style?: React.CSSProperties;
    alignLoader?: "LEFT" | "RIGHT";
    label: string | React.ReactElement;
    ref?: React.ForwardedRef<HTMLSpanElement>;
    onClick: (done: () => Promise<void>, e?: any) => void;
}

function StatefulLink(props: StatefulLinkProps) {

    const [clicked, setClicked] = React.useState<boolean>(false);

    return (<span ref={props.ref} style={props.style} className={Classname.build("link stateful", props.className, { "noseur-disabled": clicked })} onClick={(e: any) => {
        setClicked(true);
        props.onClick(async () => {
            setClicked(false);
        }, e);
    }}> {(clicked && props.alignLoader === "LEFT") && (<i className="fas fa-spinner fa-pulse left" />)} {props.label} {(clicked && (!props.alignLoader || props.alignLoader === "RIGHT")) && (<i className="fas fa-spinner fa-pulse right" />)}</span>);

}

export default StatefulLink;
